import { createFileRoute, redirect } from '@tanstack/react-router';

import { buildLoginSearch } from '@/shared/redirect/build-login-search';

export const Route = createFileRoute('/')({
  beforeLoad: ({ location }) => {
    throw redirect({
      search: buildLoginSearch(location.searchStr),
      to: '/login',
    });
  },
});
